import { render, staticRenderFns } from "./CouponRedeemSuccess.vue?vue&type=template&id=ae22ab2a&"
import script from "./CouponRedeemSuccess.vue?vue&type=script&lang=js&"
export * from "./CouponRedeemSuccess.vue?vue&type=script&lang=js&"
import style0 from "./CouponRedeemSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports